import React, { useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";

// material components
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { ArrowLeft, ArrowRight } from "@material-ui/icons";
import Box from "@material-ui/core/Box";
import { Container, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

// styles
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";

// context

// layout
import AuthLayout from "../components/AuthLayout";

import useStyles from "../styles/index";
import { sanaBaseUrl } from '../constants';
import { StyledHelper } from '../styles/globalStyle';

// context

// api

// layout
const typeOptions = [
  { value: "byVoice", label: "خواندن متن" },
  // { value: "byMovment", label: "حرکت سر" },
];

const SelectAuthType = () => {
  const history = useHistory();
  // style
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [authType, setAuthType] = React.useState("byVoice");

  useEffect(() => {

    let timerRemiander = setTimeout(() => {
      window.location.href = sanaBaseUrl;

    }, 600000);

    return () => {

      clearTimeout(timerRemiander)
    };

  }, []);

  // const handleChangeType = (
  //   event: React.MouseEvent<HTMLElement>,
  //   value: string
  // ) => {
  //   if (value) setAuthType(value);
  // };

  const StyledToggleButton = withStyles((theme) => ({
    root: {
      "&$selected": {
        backgroundColor: "#0088ff",
        color: theme.palette.common.white,

        "&:hover": {
          backgroundColor: "#943d8130",
        },
      },
      "&:hover": {
        backgroundColor: "#943d8130",
      },
      borderRadius: 10,
      border: "1px solid #0088ff",
      backgroundColor: "#fff",
      height: 35,
      width: 200,
    },
    selected: {},
  }))(ToggleButton);


  const next = () => {
    history.replace({ pathname: "/selfie", state: { authType } });
  };
  const back = () => {
    history.replace("/selfieImage");

  };

  return (
    <AuthLayout showInfo={false}>
      <div className={classes.root}>
        <Container className={classes.content}>
          {/* <span style={{ marginTop: 40, marginBottom: 10 }}>
            یکی از دو روش زیر را به دلخواه برای ضبط ویدئو سلفی انتخاب کنید:
          </span> */}
          {/* <ToggleButtonGroup
            style={{ marginTop: 20 }}
            value={authType}
            exclusive
            onChange={handleChangeType}
            aria-label="Protocol"
          >
            {typeOptions.map((option) => (
              <StyledToggleButton
                key={option.label}
                value={option.value}
                aria-label={option.label}
              >
                {option.label}
              </StyledToggleButton>
            ))}
          </ToggleButtonGroup> */}


          {authType === "byVoice" ? (
            <>
              <img
                style={{ width: "30%", }}
                src="./speech.png"
                alt="frame"
              />

              <Typography
                style={{
                  // backgroundColor: 'rgb(189 7 112)',
                  backgroundColor: '#0088ff',
                  padding: '8px',
                  margin: '8px',
                  borderRadius: '4px',
                  color: '#ffffff'
                }}
              >
                ویدئو سلفی
              </Typography>

            </>
          ) : (
            <img
              style={{ width: "30%", }}
              src="./direction.gif"
              alt="frame"
            />
          )}
          <div style={{ width: "100%", marginBottom: 20 }}>
            {authType === "byVoice" ? (
              <>
                <Typography

                  style={{
                    // backgroundColor: 'rgb(229 242 253)',
                    backgroundColor: 'rgb(229, 242, 253)',
                    padding: '8px',
                    borderRadius: '4px'
                  }}>
                  در این مرحله دوربین را به صورت <b style={{ color: 'red' }}>مستقیم</b> و در راستای صورت خود، ثابت نگه داشته، دکمه شروع را بزنید و متن خواسته شده را با <b style={{ color: 'red' }}>صدای بلند</b>  و  <b style={{ color: 'red' }}>شمرده شمرده</b> بخوانید
                  و در نهایت ویدئو ضبط شده را ارسال نمایید

                </Typography>

                <StyledHelper>
                  <span className={'title'}>  موارد زیر را رعایت کنید:</span>

                  <ul>
                    <li>
                      رعایت پوشش و حجاب، برای کلیه کاربران (آقا و خانم) الزامی
                      است.
                    </li>
                    <li>محیط، نور کافی داشته باشد.</li>
                    <li>نور از پشت سر تابیده نشود (نور آفتاب یا چراغ در پشت سر نباشد).</li>
                    <li>چهره در سایه قرار نگیرد.</li>
                    <li>به هنگام گرفتن ویدئو سلفی، دست لرزش نداشته باشد.</li>
                    <li>
                      از روشن بودن و دسترسی داشتن مرورگر به میکروفن و دوربین اطمینان
                      حاصل کنید
                    </li>
                  </ul>

                </StyledHelper>
              </>

            ) : (
              <Typography>
                در این مرحله دوربین را مقابل صورت خود ثابت نگه داشته، دکمه شروع
                را بزنید و سر خود را   به ترتیب  <b style={{ color: 'red' }}>کاملا</b> به جهت های خواسته شده بچرخانید.
              </Typography>
            )}
          </div>

          <div className={classes.actionBar}>
            <Button
              variant="outlined"
              color="primary"
              className="last"
              startIcon={<ArrowRight />}
              onClick={back}
            >
              مرحله قبل
            </Button>
            <Button
              variant="outlined"
              color="primary"
              endIcon={<ArrowLeft />}
              onClick={next}
            >
              مرحله بعد
            </Button>
          </div>
        </Container>
        <Dialog open={openDialog}>
          <DialogTitle id="simple-dialog-title">ارسال ویدئو سلفی</DialogTitle>
          <DialogContent>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <img
                style={{ maxHeight: "20vh", marginBottom: 30 }}
                src="/selfie.jpg"
                alt="selfie"
              />
            </Box>

            <div>
              موارد زیر را رعایت کنید:
              <ul>
                <li>
                  رعایت پوشش و حجاب اسلامی برای کلیه کاربران (آقا و خانم) الزامی
                  است.
                </li>
                <li>محیط نور کافی داشته باشد.</li>
                <li>نور از پشت سر تابیده نشود.</li>
                <li>چهره در سایه قرار نگیرد.</li>
                <li>به هنگام گرفتن ویدئو سلفی، دست لرزش نداشته باشد.</li>
                <li>
                  از روشن بودن و دسترسی داشتن مرورگر به میکروفن و دوربین اطمینان
                  حاصل کنید
                </li>
              </ul>
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} color="primary">
              ادامه
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </AuthLayout>
  );
};

export default withRouter(SelectAuthType);
